import { ENV_VARS } from '@/env';
import { sum } from 'es-toolkit';
import rgbHex from 'rgb-hex';
import { DIM_UOM_TYPES } from '../contants/Fields';
import { SHIPMENT_NO_HIDE_STATUSES, USER_PREFERENCES } from '../contants/common';
import { filterNullishFromObject, stringToNumber, valueToNumber } from './format';

export const isHBUser = ENV_VARS.REACT_APP_THEME === 'halliburton';

export const getStyleVariableValue = (key) => window.getComputedStyle(document.documentElement).getPropertyValue(key);

export const getPrimaryMenu = (menus) => {
  const getModifiedMenu = (localMenus = []) => {
    return isHBUser
      ? localMenus
      : [
          ...menus,
          {
            navigationID: 60,
            menuName: 'Settings',
            menuText: 'Settings',
            parentID: 6,
            subMenus: [
              // {
              //   menuName: "CompanySettings",
              //   menuText: "Company Settings",
              // },
              {
                menuName: 'TMSSettings',
                menuText: 'TMS Settings',
              },
            ],
          },
        ];
  };

  if (menus?.length > 0) {
    let parentMenu = menus.filter(({ parentID }) => !parentID);
    parentMenu = parentMenu.map((row) => ({
      ...row,
      subMenus: menus.filter(({ parentID }) => parentID === row.navigationID),
    }));

    // biome-ignore lint/style/noParameterAssign: <explanation>
    menus = parentMenu;
  } else {
    // biome-ignore lint/style/noParameterAssign: <explanation>
    menus = [];
  }

  return getModifiedMenu(menus).map((row) => ({
    ...row,
    hasSubMenu: Boolean(row?.subMenus?.length),
  }));
};

export const defaultPoStatusString = (val) => (val ? String(val) : 'O');

export const isRequiredField = (data) => Boolean(data?.find((item) => item.required));

export const calculateCube = (length, width, height, qty, unit) => {
  const lengthAsNumber = stringToNumber(length);
  const widthAsNumber = stringToNumber(width);
  const heightAsNumber = stringToNumber(height);
  const qtyAsNumber = stringToNumber(qty);
  const cube = lengthAsNumber * widthAsNumber * heightAsNumber;

  if (cube === 0) {
    return cube.toString();
  }
  if (unit === DIM_UOM_TYPES.CM || unit === 'CM') {
    let n = +cube / 1000000;
    n = (Math.round(n * 1000) / 1000).toString();
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
    if (n == 0) {
      return (Math.round(0.001 * qtyAsNumber * 1000) / 1000).toString();
    }
    return (Math.round(n * qtyAsNumber * 1000) / 1000).toString();
    // biome-ignore lint/style/noUselessElse: <explanation>
  } else if (unit === DIM_UOM_TYPES.INCHES || unit === 'IN') {
    let n = +cube / 1728;
    n = (Math.round(n * 1000) / 1000).toString();
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
    if (n == 0) {
      return (Math.round(0.001 * qtyAsNumber * 1000) / 1000).toString();
    }
    return (Math.round(n * qtyAsNumber * 1000) / 1000).toString();
    // biome-ignore lint/style/noUselessElse: <explanation>
  } else {
    return (Math.round(0.001 * qtyAsNumber * 1000) / 1000).toString();
  }
};

export const calculateExtWeightValue = (quantity, width) => {
  return quantity && width ? Math.round(stringToNumber(quantity) * stringToNumber(width) * 1000) / 1000 : 0;
};

export const calculateExtWeight = (quantity, width) => {
  const extWeightValue = calculateExtWeightValue(quantity, width);

  return extWeightValue.toLocaleString();
};

export const calculateExtVolumeValue = (quantity, cube) => {
  return cube && quantity ? Math.round(stringToNumber(quantity) * stringToNumber(cube) * 1000) / 1000 : 0;
};

export const calculateExtVolume = (quantity, cube) => {
  const extVolumeValue = calculateExtVolumeValue(quantity, cube);

  return extVolumeValue.toLocaleString();
};

export const getRateShopStringAll = (val) => (val && String(val).toLocaleUpperCase() !== 'ALL' ? val : '**');

export const calCulateFreightClass = (
  varLength,
  varWidth,
  varHeight,
  VarTotalWeight,
  VarWeightUOM,
  varTotalBilledQty,
  _VarBilledQtyUOM,
  varDimUOM,
  varTotalCube,
  varIsCmsAllowed,
) => {
  //Assuming All length width weightUOM BilledQtyUOm DimUOM should be same

  let ProductUom = '';
  let ProductWeightUom = '';
  //Inches
  let ProductLengthInches = 0;
  let ProductHeightInches = 0;
  let ProductWidthInches = 0;

  //Inches

  //Feet
  let ProductLengthFeet = 0;
  let ProductHeightFeet = 0;
  let ProductWidthFeet = 0;

  //Feet

  //Feet
  let ProductLengthCentimeter = 0;
  let ProductHeightCentimeter = 0;
  let ProductWidthCentimeter = 0;

  //Feet

  let SumProductLength = 0;
  let SumProductHeight = 0;
  let SumProductWidth = 0;

  // biome-ignore lint/correctness/noUnusedVariables: <explanation>
  let ProductQuantity = 0;
  let NumOfCube = 0;
  let NumOfCubeTotal = 0;

  let ProductWeight = 0;
  let TotalProductWeight = 0;
  let TotalBilledQuantity = 0;

  ProductUom = varDimUOM;
  ProductQuantity = varTotalBilledQty;
  ProductWeight = VarTotalWeight;

  ProductWeightUom = VarWeightUOM;

  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (ProductUom == 'FT') {
    ProductLengthFeet = varLength;
    ProductHeightFeet = varHeight;
    ProductWidthFeet = varWidth;
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  } else if (ProductUom == 'C' || ProductUom == 'CM') {
    ProductLengthCentimeter = varLength;
    ProductHeightCentimeter = varHeight;
    ProductWidthCentimeter = varWidth;
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  } else if (ProductUom == 'N' || ProductUom == 'IN') {
    ProductLengthInches = varLength;
    ProductHeightInches = varHeight;
    ProductWidthInches = varWidth;
  }

  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (ProductWeight == '') {
    return 0;
  }
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (ProductUom == '') {
    return 0;
  }
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (varIsCmsAllowed != 'Y') {
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
    if (ProductUom != 'FT') {
      // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      if (ProductUom != 'N') {
        return 0;
      }
    }
  }
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (ProductWeightUom == '') {
    return 0;
  }
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (ProductWeightUom != 'KG') {
    // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
    if (ProductWeightUom != 'LB') {
      return 0;
    }
  }

  // }

  SumProductHeight =
    Number.parseFloat(ProductHeightFeet) +
    Number.parseFloat(ProductHeightInches / 12) +
    Number.parseFloat(ProductHeightCentimeter * 0.0328084);
  SumProductLength =
    Number.parseFloat(ProductLengthFeet) +
    Number.parseFloat(ProductLengthInches / 12) +
    Number.parseFloat(ProductLengthCentimeter * 0.0328084);
  SumProductWidth =
    Number.parseFloat(ProductWidthFeet) +
    Number.parseFloat(ProductWidthInches / 12) +
    Number.parseFloat(ProductWidthCentimeter * 0.0328084);

  NumOfCube = SumProductHeight * SumProductLength * SumProductWidth;
  NumOfCubeTotal = NumOfCube;
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (ProductWeightUom == 'KG') {
    ProductWeight = Number.parseFloat(ProductWeight) * 2.205;
  }
  TotalProductWeight = ProductWeight;
  TotalBilledQuantity = varTotalBilledQty;

  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (TotalBilledQuantity == '') {
    return;
  }
  if (NumOfCubeTotal > 0) {
    /* empty */
  } else {
    NumOfCubeTotal = 0;
  }

  //All Calculated in Pound
  //NumOfCubeTotal = TotalBilledQuantity * NumOfCubeTotal;
  NumOfCubeTotal = varTotalCube;
  let Density = 0;
  Density = Number.parseFloat(TotalProductWeight) / Number.parseFloat(NumOfCubeTotal);

  let FreightClass = 0;
  if (Density > 0 && Density < 1) {
    FreightClass = 400;
  } else if (Density > 1 && Density < 2) {
    FreightClass = 300;
  } else if (Density > 2 && Density < 4) {
    FreightClass = 250;
  } else if (Density > 4 && Density < 6) {
    FreightClass = 175;
  } else if (Density > 6 && Density < 8) {
    FreightClass = 125;
  } else if (Density > 8 && Density < 10) {
    FreightClass = 100;
  } else if (Density > 10 && Density < 12) {
    FreightClass = 92.5;
  } else if (Density > 12 && Density < 15) {
    FreightClass = 85;
  } else if (Density >= 15) {
    FreightClass = 70;
  }

  return FreightClass;
};

export const validateProductForCalculateClass = (products, isHideTheRowDetails = false) => {
  return new Promise((resolve, reject) => {
    if (products) {
      products.forEach(({ dimUom }, index) => {
        if (!dimUom) {
          reject(`Dimensions Unit Of Measure is required${!isHideTheRowDetails ? ` In product ${index + 1}` : ''}.`);
        }
        if (!['FT', 'N'].includes(dimUom)) {
          reject(
            `Dimensions Unit Of Measure should be Feet/Inches Only${
              !isHideTheRowDetails ? ` In product ${index + 1}` : ''
            }.`,
          );
        }
      });
      resolve(true);
    } else {
      reject('Invalid products information!');
    }
  });
};

export const validateProductForCalculateClassQuote = (products, isHideTheRowDetails = false) => {
  return new Promise((resolve, reject) => {
    if (products) {
      products.forEach(({ dimUom }, index) => {
        if (!dimUom) {
          reject(`Dimensions Unit Of Measure is required${!isHideTheRowDetails ? ` In product ${index + 1}` : ''}.`);
        }
      });
      resolve(true);
    } else {
      reject('Invalid products information!');
    }
  });
};

export const uniqueID = () => {
  return (Math.random() + 1).toString(36).substring(2);
};

export const filterRateShopAdditionalFieldsVersionTwo = (data, filterData, accessor = 'codeDesc') => {
  let filteredList = [];
  let listForClearState = [];
  const selectedList = data?.filter((item) => item.isChecked);
  if (filterData?.searchValue && filterData?.searchValue?.length > 0) {
    if (filterData.filterType === 'START') {
      const regex = new RegExp(`^${filterData?.searchValue}`, 'gi');
      filteredList = data?.filter(({ [accessor]: recordValue }) => regex.test(recordValue) || regex.test(recordValue));
    } else {
      filteredList = data?.filter((row) => row[accessor] === filterData.searchValue);
    }
  } else {
    listForClearState = data?.filter(
      ({ lookupKey }) => selectedList.findIndex((item) => item.lookupKey === lookupKey) === -1,
    );
  }
  filteredList = filteredList?.filter(
    ({ lookupKey }) => selectedList?.findIndex((item) => item.lookupKey === lookupKey) === -1,
  );
  return [...filteredList, ...selectedList, ...listForClearState];
};

export const rgbaToHex = (rgba) => rgbHex(rgba?.r, rgba?.g, rgba?.b, rgba?.a);

// Need to enable this feature for admin users only later
const omitCssVariables = ['header', 'topMenuText', 'dark-1', 'bottomMenuText', 'font-family'];
export const applyTheme = (cssVariables) => {
  const rootElement = document.documentElement;
  if (typeof cssVariables === 'object') {
    for (const key in cssVariables) {
      if (Object.hasOwnProperty.call(cssVariables, key)) {
        if (!omitCssVariables.includes(key)) {
          rootElement.style.setProperty(`--${key}`, cssVariables[key]);
        }
      }
    }
  }
};

export const checkFormValidationStatus = (formInstance, formName) => {
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
  return new Promise(async (resolve, reject) => {
    try {
      const validationStatus = await formInstance.validateFields();
      resolve({ [formName]: validationStatus });
    } catch (error) {
      reject({ formName, ...error });
    }
  });
};

export const convertThemeApiToLocal = (data) => {
  const results = {
    header: data?.topMenuColor,
    topMenuText: data?.topMenuTextColor,
    'font-family': data?.fontFamily,
    'dark-1': data?.bottomMenuColor,
    bottomMenuText: data?.bottomMenuTextColor,
    fontSizePercent: data?.fontSize,
    preferedLanguage: data?.preferedLanguage,
    defaultDateFormat: data?.defaultDateFormat,
    timeFormat: data?.timeFormat,
    [USER_PREFERENCES.SHIPMENT_VIEW_TYPE]: data[[USER_PREFERENCES.SHIPMENT_VIEW_TYPE]],
    [USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]: data[[USER_PREFERENCES.SHIPMENT_PRODUCT_VIEW_TYPE]],
    [USER_PREFERENCES.LD_CLAIM_VIEW_TYPE]: data[[USER_PREFERENCES.LD_CLAIM_VIEW_TYPE]],
    [USER_PREFERENCES.OC_CLAIM_VIEW_TYPE]: data[[USER_PREFERENCES.OC_CLAIM_VIEW_TYPE]],
  };

  return filterNullishFromObject(results);
};

export const validateForm = (formInstance, formName) => {
  // eslint-disable-next-line no-async-promise-executor
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
  return new Promise(async (resolve, reject) => {
    try {
      const validationStatus = await formInstance.validateFields();
      resolve({ [formName]: validationStatus });
    } catch (error) {
      reject({ formName, ...error });
    }
  });
};

export const hyphenOneToEmptyInObject = (object) => {
  if (object) {
    if (typeof object === 'object') {
      for (const key in object) {
        if (Object.hasOwnProperty.call(object, key)) {
          // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
          if (object[key] == '-1') {
            object[key] = '';
          }
        }
      }
    }
  }
  return object;
};

export const validateShipmentNoVisibility = (approvalNo, status) =>
  String(approvalNo ? approvalNo : '').trim().length > 0 &&
  SHIPMENT_NO_HIDE_STATUSES.includes(String(status).toUpperCase());

// biome-ignore lint/style/useDefaultParameterLast: <explanation>
export const generateStopNumbers = (n = 0, stopType) => {
  const options = [];

  if (typeof n === 'number') {
    for (let i = 1; i <= n; i++) {
      // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
      if (stopType == '2' && i === 1) continue;
      options.push({ value: i, label: i });
    }
  }

  return options;
};

export const checkIsPartialShipment = (status) => String(status).toUpperCase() === 'PARTIAL';

export const rateShopTransform = (obj) => {
  const details = obj?.shipmentSummaryList?.map((row) => {
    return {
      SequenceNumber: row.gId,
      NumberOfPieces: row.quantityShipped,
      ActualWeight: 0.0,
      BilledWeight: row.totalWeight,
      BilledWeightUOM: row.weightUomCode,
      RatingClass: row.class,
      MeasurementType: row.weightUomCode,
      BilledQuantity: row.puomTotalQuantity,
      Length: row.length,
      Width: row.width,
      Height: row.height,
      Cube: row.cube,
      CubeUOM: null,
      ProductCode: '',
      TrailerKey: 0,
    };
  });
  return {
    Accessorials: [
      {
        AccessorialCode: 'FUE',
        Description: 'FUEL SURCHARGE (FUE)',
        BilledAmount: 0.0,
        CurrencyCode: null,
      },
    ],
    Details: details,
    Lanes: [
      {
        Id: 1,
        LaneKey: 0,
        Origin: {
          Port: {
            Key: 0,
            Type: obj?.shipperList?.[0]?.portType,
            Code: obj?.shipperList?.[0]?.portCode,
          },
          Key: -1,
          Address1: obj?.shipperList?.[0]?.address,
          Address2: null,
          City: obj?.shipperList?.[0]?.city,
          StateCode: obj?.shipperList?.[0]?.stateCode,
          CountryCode: obj?.shipperList?.[0]?.statcountryCode,
          Postal: obj?.shipperList?.[0]?.zip,
          PostalTo: null,
          BranchKey: -1,
        },
        Destination: {
          Port: {
            Key: 6817,
            Type: 'SEA',
            Code: 'OLS',
          },
          Key: -1,
          Address1: obj?.consigneeList?.[0]?.consigneeAddr1,
          Address2: null,
          City: obj?.consigneeList?.[0]?.consigneeCity,
          StateCode: obj?.consigneeList?.[0]?.consigneeStateCode,
          CountryCode: obj?.consigneeList?.[0]?.countryCode,
          Postal: obj?.consigneeList?.[0]?.consigneeZip,
          PostalTo: null,
          BranchKey: -1,
        },
        MileageMile: 0.0,
      },
    ],
    Stops: [
      {
        LaneId: null,
        Sequence: null,
        Type: null,
        ShipRecKey: null,
        Location: {
          Port: {
            Key: null,
            Type: null,
            Code: null,
          },
          Key: null,
          Address1: null,
          Address2: null,
          City: null,
          StateCode: null,
          CountryCode: null,
          Postal: null,
          PostalTo: null,
          BranchKey: null,
        },
        NumberPieces: null,
        Mileage: null,
        Weight: null,
        LegMiles: null,
        TotalCharge: null,
        ActualCity: null,
        ActualState: null,
        TripMiles: null,
      },
    ],
    Taxes: [
      {
        TaxCode: null,
        Description: null,
        BilledAmount: null,
        CurrencyCode: null,
      },
    ],
    CriteriaId: 1,
    Source: 'RateShop',
    AuditType: null,
    CustomerKey: obj?.customerKey,
    CarrierKey: '-1',
    BranchKey: obj?.branchKey,
    TrailerKey: -1,
    ShipmentDate: obj?.shipDate,
    DeliveryDate: '',
    PricingType: 'PACT',
    PricingBasis: '**',
    CurrencyCode: 'USD',
    CargoType: '**',
    WeightUnitOfMeasure: obj?.shipmentSummaryList?.[0]?.weightUomCode,
    ServiceKey: -1,
    ServiceCode: null,
    ServiceDescription: null,
    IntercompanyType: null,
    DiscountMode: null,
    ShipmentTerms: obj?.shipmentItemlist?.[0]?.shipmentTerms,
    TimeFrame: 'C',
    TransportationMode: '**',
    LinerCode: null,
    LinerType: null,
    AccountNumber: null,
    IsShipmentRateshop: 'N',
    PackageBranchKeys: '-1',
    MileageMile: 0.0,
    MileageKilometer: 0.0,
    Weight: 120.0,
    Cube: obj?.shipmentSummaryList?.[0]?.cube,
    RatingClass: obj?.shipmentSummaryList?.[0]?.class,
    NumberOfPieces: obj?.shipmentItemlist?.[0]?.quantityShipped,
    Length: obj?.shipmentSummaryList?.[0]?.length,
    Width: obj?.shipmentSummaryList?.[0]?.width,
    Height: obj?.shipmentSummaryList?.[0]?.height,
    ProductCode: '',
    Debug: false,
    TaxableValue: 0.0,
    DeclaredValue: 0.0,
    CODValue: 0.0,
    LDMValue: 0.0,
    ItemLevelRating: false,
    ContractNumber: null,
    FreightChargeBilled: 0.0,
    TotalAccessorialBilled: 0.0,
  };
};

export const stopPropagation = (e) => {
  e.stopPropagation();
  e.nativeEvent.stopImmediatePropagation();
};

export const validateForms = (formInstance, formName) => {
  // eslint-disable-next-line no-async-promise-executor
  // biome-ignore lint/suspicious/noAsyncPromiseExecutor: <explanation>
  return new Promise(async (resolve, reject) => {
    try {
      const validationStatus = await formInstance.validateFields();
      resolve({ [formName]: validationStatus });
    } catch (error) {
      reject({ formName, ...error });
    }
  });
};

export const downloadBlobFile = (blob, fileName, isBlob = true) => {
  const link = document.createElement('a');
  const url = isBlob ? window.URL.createObjectURL(blob) : blob;
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  setTimeout(() => {
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  }, 1000);
};

export const filteredCollaborators = (collaborators) =>
  collaborators.map((c) => ({
    notificationsEnabled: c.notificationsEnabled,
    userId: c.userId,
    emails: c.email,
    group: c.group,
  }));

export const getCarriersKeys = (carriers) => carriers.map((c) => c.carrierKey || c.carrierId);
export const getCarriersNames = (carriers) => carriers.map((c) => c.carrierName || c.transportationProvider);

export const getCarriersPayload = (carriers) => {
  return carriers.reduce((acc, value) => {
    return [
      // biome-ignore lint/performance/noAccumulatingSpread: <explanation>
      ...acc,
      {
        carrierKey: value.carrierKey || value.carrierId,
        carrierName: value.carrierName || value.transportationProvider,
        routingGuideId: value.routingGuideId,
        Emails: value?.email || value?.Email,
      },
    ];
  }, []);
};

export const generateUPSPortalURL = (clientID) =>
  `${ENV_VARS.REACT_APP_RATE_UPS_AUTH}${clientID}&redirect_uri=${window.location.origin}/shipment/parcel-express&response_type=code&type=ups_com_api`;

export const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch {
    return false;
  }
};

export const getSmallParcelSelectedAccountNumberForUPS = ({ shipmentTerms, shipperAccountNo, upsAccount }) => {
  let accountNo;
  // biome-ignore lint/suspicious/noDoubleEquals: <explanation>
  if (shipmentTerms == '3') {
    accountNo = shipperAccountNo;
  } else {
    accountNo = upsAccount;
  }
  return accountNo;
};

const getProductTotalValues = (form, value) => {
  if (form?.getFieldValue('items') && value) {
    return sum(form.getFieldValue('items')?.map((i) => stringToNumber(i[value])));
  }
  return '';
};

export const getQuoteProductFooterFields = (form, t, formItems = []) => {
  const firstItem = formItems?.[0] || {};
  const weightUom =
    firstItem.weightUom === 'KG'
      ? t('translation:getQuote.productDetails.kilogram')
      : t('translation:getQuote.productDetails.pound');

  let dimUom;
  if (firstItem.dimUom === 'C') {
    dimUom = t('translation:getQuote.productDetails.cbm');
  } else if (firstItem.dimUom === 'N') {
    dimUom = t('translation:getQuote.productDetails.cuft');
  } else {
    dimUom = t('translation:getQuote.productDetails.inches');
  }

  const totalWeightValue = sum(
    formItems.map((item) => {
      const weight = stringToNumber(item.weight) || 0;
      const quantity = stringToNumber(item.quantity) || 0;
      if (firstItem.weightUom === 'KG') {
        return item.weightUom === 'KG' ? weight * quantity : (weight / 2.2046) * quantity;
        // biome-ignore lint/style/noUselessElse: <explanation>
      } else {
        return item.weightUom === 'KG' ? weight * 2.2046 * quantity : weight * quantity;
      }
    }),
  );

  // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
  const totalWeightValueFormatted = isNaN(totalWeightValue) ? '0' : totalWeightValue.toLocaleString();

  const allDimUOMsSame = formItems.every((item) => item.dimUom === firstItem.dimUom);

  const totalCubeValue = () => {
    const totalCube = allDimUOMsSame
      ? sum(
          formItems.map((item) =>
            calculateExtVolumeValue(stringToNumber(item.quantity) || 0, stringToNumber(item.cube) || 0),
          ),
        )
      : sum(
          formItems.map(
            (item) =>
              (stringToNumber(item.quantity) || 0) *
              (item.dimUom === 'N' ? stringToNumber(item.cube) || 0 : stringToNumber(item.cube) * 35.314 || 0),
          ),
        );

    if (formItems.length > 1 && !allDimUOMsSame) {
      return totalCube / (firstItem.dimUom === 'N' ? 1 : 35.314);
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return totalCube;
    }
  };

  // biome-ignore lint/suspicious/noGlobalIsNan: <explanation>
  const totalCubeValueFormatted = isNaN(totalCubeValue()) ? '0' : totalCubeValue().toLocaleString();

  const footerFields = [
    {
      label: t('translation:getQuote.productDetails.totalWeight'),
      value: totalWeightValueFormatted,
    },
    {
      label: t('translation:getQuote.productDetails.totalWeightUnitOfMeasure'),
      value: weightUom,
    },
    {
      label: t('translation:getQuote.productDetails.totalQuantity'),
      value: getProductTotalValues(form, 'quantity'),
    },
    {
      label: t('translation:getQuote.productDetails.totalDimUnitOfMeasure'),
      value: dimUom,
    },
    {
      label: t('translation:getQuote.productDetails.totalCube'),
      value: totalCubeValueFormatted,
    },
  ];

  return footerFields;
};

export const getQuotePayloadProductTotals = (formItems = []) => {
  const firstItem = formItems[0] || {};
  const totalWeightValue = sum(
    formItems.map((item) => {
      const weight = stringToNumber(item.weight) || 0;
      const quantity = stringToNumber(item.quantity) || 0;
      if (firstItem.weightUom === 'KG') {
        return item.weightUom === 'KG' ? weight * quantity : (weight / 2.2046) * quantity;
        // biome-ignore lint/style/noUselessElse: <explanation>
      } else {
        return item.weightUom === 'KG' ? weight * 2.2046 * quantity : weight * quantity;
      }
    }),
  );

  const allDimUOMsSame = formItems.every((item) => item.dimUom === firstItem.dimUom);
  const getTotalCubeValue = () => {
    const totalCube = allDimUOMsSame
      ? sum(
          formItems.map((item) =>
            calculateExtVolumeValue(stringToNumber(item.quantity) || 0, stringToNumber(item.cube) || 0),
          ),
        )
      : sum(
          formItems.map(
            (item) =>
              (stringToNumber(item.quantity) || 0) *
              (item.dimUom === 'N' ? stringToNumber(item.cube) || 0 : stringToNumber(item.cube) * 35.314 || 0),
          ),
        );

    if (formItems.length > 1 && !allDimUOMsSame) {
      return totalCube / (firstItem.dimUom === 'N' ? 1 : 35.314);
      // biome-ignore lint/style/noUselessElse: <explanation>
    } else {
      return totalCube;
    }
  };
  const totalCubeValue = getTotalCubeValue();
  return {
    totalWeight: valueToNumber(totalWeightValue.toFixed(3)),
    totalUnits: sum(formItems.map((item) => stringToNumber(item.quantity) || 0)),
    totalCube: valueToNumber(totalCubeValue.toFixed(3)),
  };
};

export const checkBidExpiryWithLastMinutes = (time, lastMinutes = 10) => {
  if (typeof time === 'string') {
    const [hours, minutes, seconds] = time.split(':').map(Number);
    const totalSeconds = hours * 3600 + minutes * 60 + seconds;
    return totalSeconds < lastMinutes * 60;
  }
  return false;
};
